export default __webpack_public_path__ + "static/media/printer.5d9b270e.svg";